import ENDPOINTS from "../ApiManager/EstablecimientoEndPoints";
import environment from "../environments/environment";

const BASE_URL = environment.api_url;

class EstablecimientoService {
	
	static getEstablecimientos = () => {
		const url = BASE_URL + ENDPOINTS.GET_ESTABLECIMIENTOS();
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			}
		});
	};
	
	static getEstablecimientosByParams = (nombre, activo, cadena) => {
		const url = BASE_URL + ENDPOINTS.GET_ESTABLECIMIENTOS_BY_PARAMS(nombre, activo, cadena);
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			}
		});
	};
	
	static getEstablecimientoById = (id) => {
		const url = BASE_URL + ENDPOINTS.GET_ESTABLECIMIENTO_BY_ID(id);
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			}
		});
	};
	
	static crearEstablecimiento = (establecimiento) => {
		const url = BASE_URL + ENDPOINTS.CREAR_ESTABLECIMIENTO();
		
		return fetch(url, {
			method: 'POST',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				nombre: establecimiento.nombre,
		        pais: establecimiento.pais,
		        cadena: establecimiento.cadena,
		        direccionActividad: establecimiento.direccionActividad,
		        cpActividad: establecimiento.cpActividad,
		        localidadActividad: establecimiento.localidadActividad,
		       	direccionFiscal: establecimiento.direccionFiscal,
		        cpFiscal: establecimiento.cpFiscal,
		        localidadFiscal: establecimiento.localidadFiscal,
		        mailAdmin: establecimiento.mailAdmin,
		        telefonoRecepcion: establecimiento.telefonoRecepcion,
				mailMantenimiento: establecimiento.mailMantenimiento,
				movilMantenimiento: establecimiento.movilMantenimiento,
				cif: establecimiento.cif,
		        activo: establecimiento.activo,
		        permitirAsignarHabitaciones: establecimiento.permitirAsignarHabitaciones
			})
		});
	};
	
	static actualizarEstablecimiento = (establecimiento) => {
		const url = BASE_URL + ENDPOINTS.ACTUALIZAR_ESTABLECIMIENTO(establecimiento.id);
		
		return fetch(url, {
			method: 'PUT',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				nombre: establecimiento.nombre,
		        pais: establecimiento.pais,
		        cadena: establecimiento.cadena,
		        direccionActividad: establecimiento.direccionActividad,
		        cpActividad: establecimiento.cpActividad,
		        localidadActividad: establecimiento.localidadActividad,
		       	direccionFiscal: establecimiento.direccionFiscal,
		        cpFiscal: establecimiento.cpFiscal,
		        localidadFiscal: establecimiento.localidadFiscal,
		        mailAdmin: establecimiento.mailAdmin,
		        telefonoRecepcion: establecimiento.telefonoRecepcion,
				mailMantenimiento: establecimiento.mailMantenimiento,
				movilMantenimiento: establecimiento.movilMantenimiento,
				cif: establecimiento.cif,
		        activo: establecimiento.activo,
		        permitirAsignarHabitaciones: establecimiento.permitirAsignarHabitaciones
			})
		});
	};
	
	static desactivarEstablecimiento = (establecimientoId) => {
		const url = BASE_URL + ENDPOINTS.DELETE_ESTABLECIMIENTO() + establecimientoId;
		
		return fetch(url, {
			method: 'DELETE',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};
	
	
}

export default EstablecimientoService;